const Form015EN = {
    stepName: {
        ImportantNotes: "Important Notes",
        PersonalInfo: "Teacher's Information",
        Nominate: "Nominated Rewards",
        ServiceRecord: "Service Record",
        Confirmation: "Confirmation",
    },
    importantNotes: {
        p_title: "Personal Information Collection Statement",
        p1_1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        p1_a: "processing employment-related matters;",
        p1_b: "processing Salaries Grant payment and calculation of provident fund contribution and donation;",
        p1_c: "auditing;",
        p1_d: "conducting research and compiling statistics to facilitate planning of education services;",
        p1_e: "processing matters relating to the development of the education profession;",
        p1_f: "administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules (Cap. 279).",

        p2: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        p3: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above.",
        p4: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        p5: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
    },
    errorMsg: {
        "E-0106": "AA000000(A)",
        "E-0101": "number Chinese is not allowed",
        "E-0102": "Please enter Chinese",
        college: "Name of College",
        notPublicUser: "This form should be only submitted by public user.",
    },
    titleOption: {
        Mr: "Mr.",
        Mrs: "Mrs.",
        Miss: "Miss",
    },
    label: {
        ImportantNotesContent: {
            title: "Personal Information Collection Statement",
            p_title: "Purpose of Collection",
            p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
            p1_a: "Activities relating to the processing, authentication and counter-checking of the application for registration of teachers;",
            p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
            p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
            p1_d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            p1_e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
            p1_f: "Activities relating to compilation of statistics, research and Government publications; and",
            p1_g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules), the Codes of Aid and the Post Secondary Colleges Ordinance (Cap. 320) and its subsidiary legislation.",

            p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

            p_title3: "Classes of Transferees",
            p3_1: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
            p3_a: "other Government bureau and departments, including Hong Kong Police Force, for the purposes mentioned in paragraph 1 above;",
            p3_b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
            p3_c: "where you have given your prescribed consent to such disclosure; and",
            p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

            p_title4: "Access to Personal Data",
            p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to Teacher Registration Team at 2/F, Trade and Industry Tower, 3 Concorde Road, Kowloon.",
            // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        },
        rewardOption: {
            Male: "Male",
            Female: "Female",
        },
        genderOption: {
            M: "Male",
            F: "Female",
        },
        regardingOption: {
            know: "are",
            notKnow: "are not",
        },
        fullTimePartTime: {
            fullTime: "Full-time",
            PartTime: "Part-time ",
        },
        unitOption: {
            perHour: "per hour",
            perWeek: "per week",
            perMonth: "per month",
        },
        partTimeHours: "Part-time hours",
        photographs: "Signed Photographs",
        certificate: "Medical Certificate",
        certificates:
            "Educational certificates, or other evidence of educational qualifications of the teacher",

        educated: "(g) Where educated with dates:",
        termsConditions:
            "I confirm that I have read and understood the relevant provisions of the Post Secondary Colleges Ordinance (Cap. 320) and Regulations (Cap.320A).",
        iamStatement:
            "I understand the applicant needs to have an “iAM Smart+” account to process the application.",
        college: "Name of College making the application",
        date: "Date",
        title: "Title",
        notes1: "1. With the approval of the College Council I hereby make application for",
        notes2: "particulars of whom are given below, to be registered as a teacher in this College.",
        notes3: "2. Teacher's particulars:",
        teacherName: "Name (in English)",
        englishName: "Name (in English)",
        chineseName: "Name (in Chinese)",
        aliases: "Aliases",
        sex: "(d) Sex",
        dateBirth: "(e) Date of Birth",
        placeBirth: "Place of Birth",
        university: "School or University",
        /* fromMonth: "From Month/Year",
        toMonth: "To Month/Year", */
        fromMonth: "From Month/Year",
        toMonth: "To Month/Year",
        educational:
            "Educational qualifications (Certificates, diplomas, degrees)",
        detailsOccupation:
            "(i) Details of occupation(s) other than teaching since leaving school, college or university",
        teachingExp: "(j) Details of all teaching experience:",
        school: "School",
        /* schoolfromMonth: "From Month/Year",
        schooltoMonth: "To Month/Year", */
        schoolfromMonth: "From Month/Year",
        schooltoMonth: "To Month/Year",
        classestaught: "Classes taught",
        subjectstaught: "Subjects taught",
        publications: "(k) Details of any publications or original research",
        subjectsTaught: "<b>3. Subjects to be taught</b>",
        subjectsTaughtError: "Subjects to be taught",
        subjectsTaughtCon: "3. Subjects to be taught",
        proposedSalary: "<b>4. Proposed salary</b>",
        proposedSalaryCon: "4. Proposed salary",
        workingTime: "5. Full-time or part-time",
        partTime: "(if part-time, state hours)",
        regarding3:
            "6. The following persons who <b>{{fieldName}}</b> aware of the statements made on this form may be referred to regarding the character of the teacher :---",
        regarding1: "6. The following persons who",
        regarding2:
            "aware of the statements made on this form may be referred to regarding the character of the teacher :---",
        name: "Name",
        occupation: "Occupation",
        address: "Address",
        /* qualifications:
            "I attach—(a)3 signed photographs(b)medical certificate(c)educational certificates, or other evidence of educational qualifications of the teacher", */
        qualifications: {
            attach: "7. I attach—",
            a: "(a) 3 signed photographs",
            b: "(b) medical certificate",
            c: "(c) educational certificates, or other evidence of educational qualifications of the teacher",
        },
        photograph: "Photograph",
        card: "Identity Card No.",
        president: "President (Signed)",
        otherWorkingTime: "state hours",
        identityDocment: "Identity Document",
        approverEmailAddress: "Email address",
    },
};
export default Form015EN;
